import { WHY_US } from "@/config/siteConfig";
import { Reveal, SectionHeading } from "@/components/Reveal";

export const WhyUs = () => (
  <section className="bg-navy py-16 sm:py-24 lg:py-28" data-testid="why-us-section">
    <div className="max-w-[1280px] mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeading
        dark
        label="Why RK Real Estate"
        title="Why RK Real Estate?"
        subtitle="Because finding the right property should feel simple, clear and guided."
      />

      <div className="mt-12 sm:mt-16 grid grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10 lg:gap-x-12 lg:gap-y-14">
        {WHY_US.map((f, i) => (
          <Reveal key={f.num} delay={(i % 3) * 0.1}>
            <div className="group border-t border-white/10 pt-6 hover:border-gold/60 transition-colors duration-500" data-testid={`why-us-item-${f.num}`}>
              <span className="font-display text-3xl sm:text-4xl font-semibold text-gold/80 group-hover:text-gold transition-colors duration-500">
                {f.num}
              </span>
              <h3 className="mt-4 text-base sm:text-xl font-semibold font-display text-white leading-snug">{f.title}</h3>
              <p className="mt-2.5 text-[13px] sm:text-sm text-white/60 leading-relaxed">{f.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
